import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Hail.svg",
  "use": "Hail.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Hail.svg\"><path d=\"M54,29a7,7,0,0,1-7,7H19a9,9,0,0,1-.9521-17.9487,10.9873,10.9873,0,0,1,20.4177-4.6348A7.9606,7.9606,0,0,1,48.8866,22.29,6.98,6.98,0,0,1,54,29ZM18,48a3,3,0,1,1-3,3A3,3,0,0,1,18,48Zm1-5a3,3,0,1,1,3,3A3,3,0,0,1,19,43Zm9,5a3,3,0,1,1-3,3A3,3,0,0,1,28,48Zm1-5a3,3,0,1,1,3,3A3,3,0,0,1,29,43Zm9,5a3,3,0,1,1-3,3A3,3,0,0,1,38,48Zm1-5a3,3,0,1,1,3,3A3,3,0,0,1,39,43Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol